import { useCallback, useEffect, useState } from "react";
import type { Lead } from "@/data/leads";
import { getLeads } from "@/services/leads";

export function useLeads() {
  const [leads, setLeads] = useState<Lead[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const refresh = useCallback(async () => {
    setLoading(true);
    setError("");
    try { setLeads(await getLeads()); }
    catch (cause) { setError(cause instanceof Error ? cause.message : "Unable to load enquiries."); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { void refresh(); }, [refresh]);
  return { leads, loading, error, refresh };
}

